import React from 'react';
import { Users } from 'lucide-react';

/**
 * Компонент секции данных о заявителях
 */
const ApplicantDetailsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <Users className="w-5 h-5 mr-2 text-purple-500" />
        Данные о заявителях
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип заявителя */}
        <div>
          <label htmlFor="applicantType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип заявителя
          </label>
          <select
            id="applicantType"
            name="applicantType"
            value={formData.applicantType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="adult">Взрослый (старше 18 лет)</option>
            <option value="child">Ребенок (до 18 лет)</option>
            <option value="infant">Младенец (до 2 лет)</option>
            <option value="senior">Пожилой (старше 65 лет)</option>
            <option value="disability">Человек с инвалидностью</option>
          </select>
        </div>

        {/* Количество заявителей */}
        <div>
          <label htmlFor="applicantsCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество заявителей
          </label>
          <input
            type="text"
            id="applicantsCount"
            name="applicantsCount"
            value={formData.applicantsCount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.applicantsCount ? 'input-error' : ''}`}
            placeholder="Введите количество"
          />
          {errors.applicantsCount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.applicantsCount}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-gray-200 dark:border-gray-700 text-sm text-gray-600 dark:text-gray-400">
        <p>
          <strong>Примечание:</strong> Для групповых заявок (семьи, туристические группы) укажите общее количество заявителей. Консульский сбор оплачивается за каждого заявителя отдельно, однако некоторые сервисные услуги могут быть общими.
        </p>
        <p className="mt-2">
          Для детей и других льготных категорий в некоторых странах предусмотрены сниженные ставки сборов или освобождение от оплаты.
        </p>
      </div>
    </div>
  );
};

export default ApplicantDetailsSection;